import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { createAppRouter, RouterRoot } from '../router';
import { LocaleProvider } from './providers/locale-provider';
import { ThemeProvider } from './providers/theme-provider';

const createClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1
      }
    }
  });

const App = () => {
  const queryClient = useMemo(() => createClient(), []);
  const router = useMemo(() => createAppRouter(queryClient), [queryClient]);

  return (
    <LocaleProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <RouterRoot router={router} />
        </QueryClientProvider>
      </ThemeProvider>
    </LocaleProvider>
  );
};

export default App;
